import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { inputErrorState, inputFormValueState } from '../../stores/formState';
import { toFirstString } from '../../utils/toFirstString';
import { DatePicker } from '../datepicker/DatePicker';

export interface DateInputProps {
  componentId: string;
  name: string;
  optional: boolean;
  message?: string;
  min?: string;
  max?: string;
  placeholder?: string;
  focus?: boolean;
  autoComplete?: string;
  initValue?: string;
}

const DateInput: React.FC<DateInputProps> = props => {
  const [value, setValue] = useRecoilState(inputFormValueState(props.componentId));
  const [inputValue, setInputValue] = useState<string | null>();
  const [error, setError] = useRecoilState(inputErrorState(props.componentId));

  useEffect(() => {
    if (value != null) {
      setInputValue(toFirstString(value));
    }
  }, [value]);

  const onChange = (value: string) => {
    setInputValue(value);
    setValue(value);
    setError(null);
  }

  const valueStr = inputValue != null ? String(inputValue) : '';

  return (
    <div className={`text-input date ${error != null ? 'invalid' : ''}`}>
      <span>
      {props.message ? <span className="message">{props.message}</span> : ''}
      <span className="optional">({props.optional ? "任意" : "必須"})</span>
      </span>
      <span className="text-input-inner">
        <DatePicker
          value={valueStr}
          onChange={onChange}
          min={props.min}
          max={props.max}
          placeholder={props.placeholder}
          initValue={props.initValue}
        />
      </span>
      <span className="error-message">{error}</span>
    </div>
  );
};

export default DateInput;
